import { INotification } from '@interfaces/INotification';

export interface INotificationsState {
  notifications: INotification[];
}

export const initialNotificationsState: INotificationsState = {
  notifications: [],
};
